import { get } from 'lodash';
import i18n from 'i18n';

const parentalLockItems = [
  // { title: 'Статус', name: 'isParentalEnabled', value: 'isParentalEnabled' },
  { title: i18n.t('pc.age.title'), name: 'age', path: 'age', value: 'age' },
  { title: i18n.t('pc.purchase.title'), name: 'purchase', path: 'purchase', value: 'purchase' },
  { title: i18n.t('pc.pinChange'), name: '', path: 'pin', value: 'pin' },
];

const getToast = state => get(state, ['toast', 'show']);
const getParentalLockItems = () => parentalLockItems;
const getParentalData = state => get(state, ['parental', 'data']);

export default state => {
  return {
    show: getToast(state),
    parentalLockItems: getParentalLockItems(state),
    parentalData: getParentalData(state),
  };
};
